import angular from 'angular';
import InvoiceService from './invoice.service';

let invoiceServiceModule = angular.module('invoiceservice', [])
  .service('InvoiceService', InvoiceService);

export default invoiceServiceModule;



// WEBPACK FOOTER //
// ./client/common/services/invoices/invoices.js